import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  containerContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: 900,
    width: '100%',
    margin: '0 auto',
    gap: theme.spacing(2)
  },
  title: {
    marginTop: theme.spacing(3),
    width: '80%',
    height: '2.5rem',
    [theme.breakpoints.down('sm')]: {
      height: '2rem'
    }
  },
  writer: {
    width: '40%',
    height: '1.2rem'
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '60%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  image: {
    borderRadius: '30px',
    width: '100%',
    height: '400px',
    [theme.breakpoints.down('sm')]: {
      height: '250px'
    }
  },
  altImage: {
    width: '30%',
    height: '1rem',
    marginTop: theme.spacing(1)
  },
  tagTitle: {
    width: '15%',
    height: '2rem'
  },
  tagsContainer: {
    display: 'flex',
    alignSelf: 'start',
    gap: theme.spacing(1),
    paddingTop: theme.spacing(2),
    flexWrap: 'wrap'
  },
  tags: {
    width: '80px',
    height: '35px',
    borderRadius: '20px'
  }
}))
